'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateUnseenThreadsCount = undefined;

var _reselect = require('reselect');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getCurrentThread = require('./getCurrentThread');

var _calculateUnseenThreadsCountExcludeCurrent = require('./calculateUnseenThreadsCountExcludeCurrent');

var calculateUnseenThreadsCount = exports.calculateUnseenThreadsCount = (0, _reselect.createSelector)([_getCurrentThread.getCurrentThread, _calculateUnseenThreadsCountExcludeCurrent.calculateUnseenThreadsCountExcludeCurrent], function (currentThread, unseenCount) {
  if (!currentThread) {
    return unseenCount;
  }

  return unseenCount + ((0, _threadGetters.getUnseenCount)(currentThread) ? 1 : 0);
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/calculateUnseenThreadsCount.js
// module id = 124
// module chunks = 2 3